import { styled } from "@linaria/react";
import { BIG_LAYOUT_WIDTH_PX, MEDIUM_LAYOUT_WIDTH_PX, SIDE_PANEL_OPENED_CN } from ".";

const SMALL_PADDING_PX = 24;
const MEDIUM_PADDING_PX = 36;
const BIG_PADDING_PX = 48;

export const SMALL_GAP_PX = 12;
export const MEDIUM_GAP_PX = 16;
export const BIG_GAP_PX = 20;

const SidePanelLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  /* SMALL */
  padding: ${SMALL_PADDING_PX}px;
  gap: ${SMALL_GAP_PX}px;

  /* MEDIUM */
  @media (min-width: ${MEDIUM_LAYOUT_WIDTH_PX}px) {
    padding: ${MEDIUM_PADDING_PX}px;
    gap: ${MEDIUM_GAP_PX}px;

    .${SIDE_PANEL_OPENED_CN} & {
      padding: ${MEDIUM_PADDING_PX}px ${SMALL_PADDING_PX}px;
    }
  }

  /* BIG */
  @media (min-width: ${BIG_LAYOUT_WIDTH_PX}px) {
    padding: ${BIG_PADDING_PX}px;
    gap: ${BIG_GAP_PX}px;

    .${SIDE_PANEL_OPENED_CN} & {
      padding: ${BIG_PADDING_PX}px;
    }
  }

  /* PRINT */
  @media print {
    padding: ${SMALL_PADDING_PX}px;
    gap: ${SMALL_GAP_PX}px;
  }
`;

export default SidePanelLayout;
